const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Galeria do produto: pre-carrega as fotos seguintes depois do load da pagina,
   em prioridade baixa, para o arraste lateral ser instantaneo sem atrasar a 1a foto. */
(function () {
  function prefetchProductGallery() {
    var imgs = document.querySelectorAll('.product__media-list img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('fetchpriority', 'low');
      imgs[i].removeAttribute('loading');
    }
  }

  function schedule() {
    setTimeout(prefetchProductGallery, 400);
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();

/* Galeria no celular:
   1. nenhuma foto passa da altura da 1a foto do produto (teto 2:3); a foto mais
      comprida diminui e fica centralizada, com borda branca nas laterais;
   2. a parte visivel da galeria acompanha o dedo entre uma foto e outra.
   IMPORTANTE: a altura da lista (o container que rola) NUNCA muda durante o
   arraste. Mudar a altura do container com scroll-snap faz o iPhone pular
   fotos. O ajuste e feito com margin-bottom negativa + clip-path, que nao
   mexem na area de rolagem. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var MAX_RATIO = 1.5;

  function ratioOf(img) {
    var w = img.naturalWidth || parseFloat(img.getAttribute('width')) || 0;
    var h = img.naturalHeight || parseFloat(img.getAttribute('height')) || 0;
    return w && h ? h / w : 0;
  }

  function setup(list) {
    if (list.getAttribute('data-adaptive')) return;
    list.setAttribute('data-adaptive', '1');
    var raf = 0;
    var heights = [];
    var maxH = 0;

    function items() {
      return [].slice.call(list.children).filter(function (el) { return el.tagName === 'LI'; });
    }

    var first = items()[0];
    var firstImg = first && first.querySelector('img');
    var capRatio = firstImg ? ratioOf(firstImg) : MAX_RATIO;
    if (!capRatio || capRatio > MAX_RATIO) capRatio = MAX_RATIO;

    function fitImages() {
      var w = list.clientWidth || 1;
      var cap = Math.round(w * capRatio);
      items().forEach(function (li) {
        var img = li.querySelector('img');
        if (!img) return;
        var r = ratioOf(img);
        if (mq.matches && r && r * w > cap + 1) {
          img.style.setProperty('height', cap + 'px', 'important');
          img.style.setProperty('width', 'auto', 'important');
          img.style.setProperty('max-width', '100%', 'important');
          img.style.setProperty('margin', '0 auto', 'important');
          img.style.setProperty('display', 'block', 'important');
        } else {
          ['height', 'width', 'max-width', 'margin', 'display'].forEach(function (p) { img.style.removeProperty(p); });
        }
      });
    }

    function clear() {
      list.style.removeProperty('margin-bottom');
      list.style.removeProperty('clip-path');
      list.style.removeProperty('-webkit-clip-path');
    }

    function measure() {
      heights = items().map(function (li) { return li.offsetHeight; });
      maxH = heights.length ? Math.max.apply(null, heights) : 0;
    }

    function apply() {
      if (!mq.matches) {
        clear();
        list.style.removeProperty('align-items');
        return;
      }
      if (!heights.length) measure();
      var n = heights.length;
      if (!n) return;
      var w = list.clientWidth || 1;
      var pos = list.scrollLeft / w;
      if (pos < 0) pos = 0;
      if (pos > n - 1) pos = n - 1;
      var i = Math.floor(pos);
      var f = pos - i;
      var a = heights[i] || 0;
      var b = heights[Math.min(i + 1, n - 1)] || a;
      var h = Math.round(a + (b - a) * f);
      var d = Math.max(0, maxH - h);
      list.style.setProperty('margin-bottom', (-d) + 'px', 'important');
      list.style.setProperty('clip-path', 'inset(0 0 ' + d + 'px 0)', 'important');
      list.style.setProperty('-webkit-clip-path', 'inset(0 0 ' + d + 'px 0)', 'important');
    }

    function onScroll() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(apply);
    }

    function remeasure() {
      fitImages();
      clear();
      if (mq.matches) list.style.setProperty('align-items', 'flex-start', 'important');
      measure();
      apply();
    }

    list.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(remeasure); });
    items().forEach(function (li) {
      var img = li.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', remeasure, { once: true });
    });
    if (window.MutationObserver) {
      new MutationObserver(remeasure).observe(list, { childList: true });
    }
    remeasure();
  }

  function init() {
    var l = document.querySelectorAll('.product__media-wrapper .product__media-list');
    for (var i = 0; i < l.length; i++) setup(l[i]);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  window.addEventListener('load', function () {
    var l = document.querySelectorAll('.product__media-wrapper .product__media-list');
    for (var i = 0; i < l.length; i++) l[i].dispatchEvent(new Event('scroll'));
  });
})();
